import { apiSlice } from '../../api/apiSlice';
import { CREATE_SCORECARD_WINDOW_COMMENTS, SCORECARD_WINDOW_COMMENTS } from '../../constants';

export const WindowCommentsSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardWindowComments: builder.query({
            query: (arg:any) => {
                const { scorecardApprovalWindowId } = arg;
                return {
                    url: SCORECARD_WINDOW_COMMENTS,
                    params : {scorecardApprovalWindowId}
                };
            },
            providesTags: ['Comments'],
        }),
        createScorecardWindowComments: builder.mutation({
            query: (arg: any) => ({
                url: CREATE_SCORECARD_WINDOW_COMMENTS,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Comments'],
        }),
    }),
});

export const {
    useGetScorecardWindowCommentsQuery,
    useCreateScorecardWindowCommentsMutation,
} = WindowCommentsSlice;
